<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Sign In As</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px"
        >

        <v-row>
            <v-col>
                <v-text-field
                    label="Search"
                    prepend-icon="mdi-magnify"
                    v-model="full_text"
                    v-on:input="update"
                    autofocus
                    @keydown.enter="onClickFirstRow"
                    autocomplete="off"
                />
            </v-col>
            <v-col
                style="flex-grow: 0"
            >
                <v-btn
                    style="margin-top: 15px"
                    v-on:click="onClickEnrolling"
                    v-if="$rc.$state.isAuthActorSystemAdmin()"
                >
                    Enrolling
                </v-btn>
            </v-col>
        </v-row>
            
       

            <v-data-table 
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                hide-default-footer 
                v-on:click:row="onClickRow"
            >
                <template v-slot:item.tags="{ item }"> 
                    <m-rc-tag-display
                        :value="item.rc_tags"
                    />
                </template>

                <template v-slot:item.is_system_admin="{ item }"> 
                    <v-simple-checkbox v-model="item.is_system_admin" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.is_organization_admin="{ item }"> 
                    <v-simple-checkbox v-model="item.is_organization_admin" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.is_archived="{ item }">
                    <v-simple-checkbox v-model="item.is_archived" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.is_organization_archived="{ item }">
                    <v-simple-checkbox v-model="item.is_organization_archived" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.has_set_password="{ item }">
                    <v-simple-checkbox v-model="item.has_set_password" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.integrations="{ item }">
                    {{$rc.pretty(item.active_integrations, 'comma_list')}}
                </template>

                <template v-slot:item.username="{ item }">
                    <v-icon
                        size="16"
                        style="position: relative; top: -2px"
                        v-on:click.stop="onClickCopyUsername(item)"
                    >
                        mdi-content-copy
                   </v-icon>
                   
                   {{item.username}}
                </template>

                <template v-slot:item.employee_label="{ item }">
                    <v-icon
                        size="16"
                        style="position: relative; top: -2px"
                        v-on:click.stop="onClickCopyName(item)"
                    >
                        mdi-content-copy
                   </v-icon>
                   
                   {{item.employee_label}}
                </template>


            </v-data-table>

        </v-card-text>

    </v-card>
    
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            full_text: null,
            results: [],
        }
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
           
            this.$rc.rest(
                'LIST: /api/v1/employees/list-sign-in-as',
            
                {
                    'full_text' : this.full_text,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },
        

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
            this.doUpdate();
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
    
            this.dialog = false;
            next(false);
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickRow(item)
        {
            
            if ( item.is_system_admin && !this.$rc.$state.hasRedChirpStaffRoleAdministrator() && item.employee_id != this.$rc.$state.getAuthEmployeeId() )
            {
                this.$rc.alert('You can not sign in as another RedChirp staff member', 'Only RedChirp staff members with the Administrator role can sign in as other RedChirp staff members');
                return;
            }

            this.signInAs(item);
        },

        onClickFirstRow()
        {
            if ( this.results.length == 0 )
                return;

            this.signInAs(this.results[0]);
        },

        signInAs(item)
        {
            let employee_id = item.employee_id;
            this.closeDialog();

            // Delay to make sure dialog has time to close...
            window.setTimeout(
                () =>{
                    this.$rc.newSignInAs(
                        {
                            'organization_id': item.organization_id,
                            'employee_id': item.employee_id,
                        }
                    );
                },
                250
            );
        },


        onClickEnrolling()
        {
            this.closeDialog();
            this.$router.push({
                'name': 'admin-search-organizations',
                'params' : {
                },
                'query': {
                    'search_state': 'pre-launch',
                },
            });
        },

        onClickCopyUsername(item)
        {   
            this.$rc.copy(item.username);
        },

        onClickCopyName(item)
        {   
            this.$rc.copy(item.employee_label);
        },


    },

    computed: {
        headers() {
            if ( this.$rc.$state.isAuthActorSystemAdmin() )
            {
                return [
                    { text: 'Tags', value: 'tags' },
                    { text: 'Organization', value: 'organization_label' },
                    { text: 'Username', value: 'username' },
                    { text: 'Name', value: 'employee_label' },
                    { text: 'System Admin', value: 'is_system_admin' },
                    { text: 'Organization Admin', value: 'is_organization_admin' },
                    { text: 'Archived', value: 'is_archived' },
                    { text: 'Has Password', value: 'has_set_password' },
                    { text: 'Integrations', value: 'integrations' },

                ];
            }
            else
            {
                return [
                    { text: 'Organization', value: 'organization_label' },
                    { text: 'Username', value: 'username' },
                    { text: 'Name', value: 'employee_label' },
                ];
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>